<template>
  <z-aside
    :class="['sider', theme, fixSiderbar ? 'ant-fixed-sidemenu' : null ]"
    :collapsible="collapsible"
    :collapsed="collapsed"
    width="200px"
    collapsedWidth="64px"
  >
    <logo></logo>
    <z-menu
      :menu="menus"
      :theme="theme"
      :collapsed="collapsed"
      @select="onSelect"
    >
    </z-menu>
  </z-aside>
</template>

<script>
import ZAside from '../layouts/z-aside'
import Logo from '../tools/logo'
import ZMenu from './index'

import { mixin } from '@/utils/mixin.js'

export default {
  name: 'SideMenu',
  components: {
    ZAside,
    Logo,
    ZMenu
  },
  mixins: [mixin],
  props: {
    theme: {
      type: String,
      required: false,
      default: 'dark'
    },
    collapsible: {
      type: Boolean,
      required: false,
      default: false
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    },
    menus: {
      type: Array,
      required: true
    }
  },
  methods: {
    onSelect (obj) {
      this.$emit('menuSelect', obj)
    }
  }
}
</script>

<style lang="scss" scoped>
.z-aside {
  overflow: initial;
}
.sider.dark {
  background-color: white;
}

.el-menu {
  margin-top: 16px;
}
.el-menu:not(.el-menu--collapse) {
  margin: 16px auto;
  width: 200px;
  min-height: 400px;
}
</style>
